var _g, _g2, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompareGradientScale1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 120,
    viewBox: "0 0 520 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.5 61H1V115.928C1 119.106 7.57887 120.993 12.513 119.205C70.2609 97.5522 134.039 81.064 201.473 70.3367L260.5 61Z",
    fill: "url(#paint0_linear_107_247)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_107_247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.5 59H518.247V4.0724C518.247 0.893944 511.712 -0.99326 506.811 0.794618C449.454 22.4478 386.106 38.936 319.128 49.6633L260.5 59Z",
    fill: "url(#paint1_linear_107_247)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 518.747,
    y: 58.5,
    width: 3.00003,
    height: 518.247,
    rx: 1.50002,
    transform: "rotate(90 518.747 58.5)",
    fill: "#BEBECE",
    stroke: "#FAFAFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_247",
    x1: 0.999998,
    y1: 84.5588,
    x2: 260.996,
    y2: 88.6891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC246"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_247",
    x1: 518.247,
    y1: 29.5515,
    x2: 260.16,
    y2: 26.1841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89E360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC545"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 259.5,
    height: 59,
    fill: "white",
    transform: "translate(1 61)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_107_247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 257.747,
    height: 59,
    fill: "white",
    transform: "translate(518.247 59) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareGradientScale1);
export default __webpack_public_path__ + "static/media/CompareGradientScale1.9ca017fa4767867ab64bb303da2a98c3.svg";
export { ForwardRef as ReactComponent };